import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'rm_cookies_accepted';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'true');
    setVisible(false);
    if (typeof window.__initPostHog === 'function') {
      window.__initPostHog();
    }
  };

  const reject = () => {
    localStorage.setItem(CONSENT_KEY, 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label={t('cookieBanner.ariaLabel')}
      className="fixed bottom-3 left-3 right-3 md:bottom-0 md:left-0 md:right-0 z-[9999] bg-[#111827] text-white px-4 py-3 md:px-8 md:py-5 shadow-2xl rounded-2xl md:rounded-none"
      style={{ marginBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center gap-3 md:gap-4">
        {/* Móvil: versión corta. Escritorio: texto completo */}
        <p className="text-xs md:text-sm text-gray-300 flex-1 line-clamp-2 md:line-clamp-none">
          <span className="md:hidden">
            {t('cookieBanner.shortText', 'Usamos cookies para mejorar tu experiencia. ')}
            <a href="/redmobility/privacidad" className="underline text-white">{t('cookieBanner.privacyLink')}</a>
          </span>
          <span className="hidden md:inline">
            {t('cookieBanner.text')}
            <a href="/redmobility/privacidad" className="underline text-white hover:text-[#39b4aa]">
              {t('cookieBanner.privacyLink')}
            </a>
            {t('cookieBanner.andText')}
          </span>
        </p>
        <div className="flex gap-2 md:gap-3 shrink-0">
          <button
            onClick={reject}
            className="flex-1 md:flex-none px-4 md:px-5 py-2 rounded-full border border-gray-600 text-xs md:text-sm font-medium hover:border-gray-400 transition-colors min-h-[40px] md:min-h-[44px]"
          >
            {t('cookieBanner.reject')}
          </button>
          <button
            onClick={accept}
            className="flex-1 md:flex-none px-4 md:px-5 py-2 rounded-full bg-[#134168] text-white text-xs md:text-sm font-bold hover:bg-[#39b4aa] transition-colors min-h-[40px] md:min-h-[44px]"
          >
            {t('cookieBanner.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
